<template>
    <div>
        {{ numberOfDispatchesLeft }} Free Dispatches Left
    </div>
</template>
<script>
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils'

export default {
    props: {
        userIsUnlimitedSubscriber: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            numberOfDispatchesLeft: '#'
        }
    },
    mounted() {
        // Only send request if we know user is not subscriber.
        if (!this.userIsUnlimitedSubscriber) {
            this.grabNumberOfDispatchesLeft();
        }
    },
    methods: {
        async grabNumberOfDispatchesLeft() {
            const token = getCookie('token');
            const userid = getCookie('userid');
            try {
                const response = await fetch(endpoint + '/api/Subscription/GetFreeDispatchesPerWeek/' + userid, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                //body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            this.numberOfDispatchesLeft = data.dispatchesRemaining;

            } catch(error) {
                console.log(error);
            }
        }
    }
}
</script>